import { FC, ReactNode } from "react";

export type ButtonProps = {
  variant: "primary" | "secondary" | "danger" | "outline-danger";
  type?: "submit" | "reset" | "button";
  disabled?: boolean;
  size?: "sm" | "md";
  fullWidth?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  "aria-label"?: string;
  children: ReactNode;
};

const variantClasses: Record<ButtonProps["variant"], string> = {
  primary: "btn-primary",
  secondary: "btn-outline-secondary",
  danger: "btn-danger",
  "outline-danger": "btn-outline-danger",
};

const Button: FC<ButtonProps> = ({
  children,
  type = "button",
  disabled,
  variant,
  size = "md",
  className = "",
  fullWidth = true,
  onClick,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    className={`btn ${variantClasses[variant]} ${
      size === "sm" ? "btn-sm" : ""
    } ${fullWidth ? "w-100" : ""} ${className}`.trim()}
    {...rest}
  >
    {children}
  </button>
);

export default Button;
